import * as React from 'react';
import Button from './Button';

const ButtonExamples: React.FC = () => {
  const handleClick = () => {
    alert('Button clicked');
  };

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h1>Button Component Examples</h1>

      {/* Basic Variants */}
      <section style={{ marginBottom: '40px' }}>
        <h2>Basic Variants</h2>
        <div style={{ display: 'flex', gap: '16px', alignItems: 'center', flexWrap: 'wrap', marginBottom: '16px' }}>
          <Button onClick={handleClick}>Default</Button>
          <Button context="talent" type="secondary" onClick={handleClick}>
            Talent Secondary
          </Button>
          <Button context="company" type="primary" onClick={handleClick}>
            Company Primary
          </Button>
          <Button disabled onClick={handleClick}>
            Disabled
          </Button>
        </div>
      </section>

      {/* Sizes */}
      <section style={{ marginBottom: '40px' }}>
        <h2>Sizes</h2>
        <div style={{ display: 'flex', gap: '16px', alignItems: 'center', flexWrap: 'wrap' }}>
          <Button size="S" onClick={handleClick}>Small</Button>
          <Button size="M" onClick={handleClick}>Medium</Button>
          <Button size="L" onClick={handleClick}>Large</Button>
        </div>
      </section>

      {/* Icons */}
      <section style={{ marginBottom: '40px' }}>
        <h2>Icons</h2>
        <div style={{ display: 'flex', gap: '16px', alignItems: 'center', flexWrap: 'wrap', marginBottom: '16px' }}>
          <Button iconLeft="file" context="talent" onClick={handleClick}>
            File
          </Button>
         <Button iconRight="arrowRight" context="talent" type="secondary" onClick={handleClick}>
            Continue
          </Button>
          <Button iconLeft="arrowLeft" context="talent" type="terceary" onClick={handleClick}>
            Back
          </Button>
          <Button disabled iconLeft="user" iconRight="image" context="company" onClick={handleClick}>
            Profile
          </Button>
          <Button iconLeft="eye" iconRight="eyeOff" context="company" onClick={handleClick} />
          <Button iconLeft="briefcaseBusiness" context="company" onClick={handleClick} />
          <Button iconRight="camera" context="neutral" onClick={handleClick} />
          <Button iconRight="calendar" context="neutral" type="secondary" onClick={handleClick} />
          <Button iconRight="x" context="neutral" type="terceary" onClick={handleClick} />
        </div>
      </section>

      {/* Links */}
      <section style={{ marginBottom: '40px' }}>
        <h2>As Links</h2>
        <div style={{ display: 'flex', gap: '16px', alignItems: 'center', flexWrap: 'wrap' }}>
          <Button href="/profile">Go to Profile</Button>
          <Button href="/jobs" type="secondary">Browse Jobs</Button>
          <Button href="https://example.com" target="_blank" iconRight="link">
            External
          </Button>
        </div>
      </section>

      {/* Dark Mode */}
      <section style={{ marginBottom: '40px', backgroundColor: '#1a1a1a', padding: '20px', borderRadius: '8px' }}>
        <h2 style={{ color: 'white' }}>Dark Mode (Neutral Context)</h2>
        <div style={{ display: 'flex', gap: '16px', alignItems: 'center', flexWrap: 'wrap' }}>
          <Button context="neutral" type="primary" onClick={handleClick}>
            Primary
          </Button>
          <Button context="neutral" type="secondary" onClick={handleClick}>
            Secondary
          </Button>
          <Button context="neutral" type="terceary" onClick={handleClick}>
            Terceary
          </Button>
        </div>
      </section>

      {/* Real-World Usage */}
      <section style={{ marginBottom: '40px' }}>
        <h2>Real-World Usage</h2>
        <div style={{ display: 'flex', gap: '16px', alignItems: 'center', flexWrap: 'wrap', marginBottom: '16px' }}>
          <Button context="talent" type="primary" size="L" onClick={handleClick}>
            Apply Now
          </Button>
          <Button context="company" type="secondary" href="/dashboard">
            Dashboard
          </Button>
          <Button iconLeft="arrowLeft" onClick={handleClick}>
            Go Back
          </Button>
        </div>
      </section>
    </div>
  );
};

export default ButtonExamples;
